<div class="filters-container">
  <form #loginForm="ngForm">

    <ng-container *ngFor="let group of validFilters">
      <h4>{{ group.title }}</h4>

      <ng-container *ngFor="let input of group.inputs" [ngSwitch]="input.type">

        <!-- CHECKBOX -->
        <div *ngSwitchCase="'checkbox'" class="checkbox-group">
          <mat-checkbox
            *ngFor="let value of input.values"
            [(ngModel)]="filterModel[value.name]"
            [name]="value.name"
            [title]="value.text">

            <span *ngIf="!value.icon">{{ value.text }}</span>

            <mat-icon
              *ngIf="value.icon"
              class="icon-alert"
              [title]="value.text">
              {{ value.icon }}
            </mat-icon>

          </mat-checkbox>
        </div>

        <!-- TEXT INPUT -->
        <div *ngSwitchCase="'text'" class="text-group">

          <mat-form-field *ngFor="let value of input.values" appearance="standard">
            <input
              matInput
              [placeholder]="value.text"
              [name]="value.name"
              [(ngModel)]="filterModel[value.name]"
              [attr.list]="value.autocomplete || null"
              [title]="filterModel[value.name]" />
          </mat-form-field>

          <div class="actions">
            <button
              mat-icon-button
              matTooltip="{{ 'common.cerca' | translate }}"
              attr.aria-label="{{ 'common.cerca' | translate }}"
              (click)="sendActiveFilters()">
              <mat-icon color="primary">search</mat-icon>
            </button>

            <button
              mat-icon-button
              matTooltip="{{ 'common.reinicia' | translate }}"
              attr.aria-label="{{ 'common.reinicia' | translate }}"
              (click)="resetActiveFilters()">
              <mat-icon color="primary">autorenew</mat-icon>
            </button>
          </div>

        </div>

        <!-- SELECT -->
        <div *ngSwitchCase="'select'" class="select-group">
          <label>{{ input.description }}</label>

          <mat-form-field appearance="standard">
            <mat-select
              [(ngModel)]="filterModel[input.name]"
              [name]="input.name">

              <mat-option
                *ngFor="let option of input.options"
                [value]="option.value">
                {{ option.text }}
              </mat-option>

            </mat-select>
          </mat-form-field>
        </div>

      </ng-container>
    </ng-container>

  </form>
</div>

<!-- DATALISTS -->
<ng-container *ngFor="let dataList of dataLists">
  <datalist [id]="dataList.id">
    <option
      *ngFor="let option of dataList.options | async"
      [value]="isTextOnly(dataList.id) ? option.text : option.value"
      [title]="option.text">
      {{ option.text }}
    </option>
  </datalist>
</ng-container>
